import { Component } from '@angular/core';

import { ChangeDetectionStrategy, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MixpanelService } from '@core/services';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';

@Component({
    selector: 'app-related-services-section',
    standalone: true,
    imports: [TranslateModule, RouterLink],
    templateUrl: './related-services-section.component.html',
    styleUrls: ['./related-services-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedServicesSectionComponent {
    readonly ckmUrl = computed(() => AppRoutes.routes().ORDERS_CHECKMATE_RETEST_LIST);

    readonly environment = environment;

    constructor(private mixpanelService: MixpanelService) {}

    logEvent(service: 'automatic-genotyping' | 'genetic-monitoring' | 'microbiome' | 'checkmate') {
        this.mixpanelService.logEvent('dashboard-open-related-services-info-' + service);
    }
}
